/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { observable, computed } from "mobx";
import { loadStatus } from "constants/enums";

class PageTile {
  @observable tileBitmap = "";
  @observable tileLoadStatus = loadStatus.NOT_LOADED;

  constructor(tileCoords) {
    if (tileCoords) {
      this.tileCoords = tileCoords;
    }
  }

  @computed
  get isLoaded() {
    return this.tileLoadStatus === loadStatus.LOADED;
  }
}

export { PageTile };
